import ContentOverlay from "../components/content_overlay";
import {Link} from "react-router-dom";
import "./abstract.css";

function AbstractPage(){
    return (
        <ContentOverlay
        heading={ <h3
            style={{
              textAlign: "center",
            }}
          >
            {" "}
            <img
              style={{ height: 30, width: 70, mixBlendMode: "multiply" }}
              src="images/india.gif"
              alt=""
            />
            &nbsp; Sahyadri Issue 92 &nbsp;
            <img
              style={{ height: 30, width: 70, mixBlendMode: "multiply" }}
              src="images/india.gif"
              alt=""
            />
          </h3> }
          
        text_content={<div className="container"><br/><p style={{fontSize:"1.5em"}}>The current issue of Sahyadri e-news (Issue XCII) reports the interplay of land cover changes with land surface temperature (LST) patterns across all agroclimatic zones in India. LULC analysis spanning 2001 to 2022, using MODIS data, reveals agriculture as the dominant land use class in ten of the fifteen agroclimatic zones, while built-up areas are rapidly expanding in select zones.<Link to="/article">Read more...</Link>  </p>
            <br />
            <br />
            <hr />
            <br />
         
          <div
            style={{
              textAlign: "center",
              borderRadius: "30px",
              marginLeft: "30px",
            }}
            className="jumbotron row container"
          >
            <div className="col-3 d-flex justify-content-evenly">
              <img
                style={{ height: 70, width: 70, mixBlendMode: "multiply" }}
                src="images/EWRG_logo.jpeg"
              />
              <img
                style={{ height: 70, width: 70, mixBlendMode: "multiply" }}
                src="images/IISc_Master_Seal.jpg"
              />
            </div>
            <div className="col-5">
              <p style={{ fontSize: "0.9999999999em", textAlign: "center" }}>
                IISc-EIACP[ENVIS CENTRE],
                <br />
                Energy & Wetlands Research Group[CES TE-15] <br />
              </p>
              <p style={{ fontSize: "0.9em", textAlign: "center" }}>
                Centre for Ecological Sciences,
                <br />
                Indian Institute of Science, Bangalore 560012,INDIA
              </p>
              <p style={{ fontSize: "0.9em", textAlign: "center" }}>
                Email:
                <a
                  href="mailto:tvr@iisc.ac.in"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  tvr@iisc.ac.in
                </a>
                ,&nbsp;
                <a
                  href="mailto:envis.ces@iisc.ac.in"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  envis.ces@iisc.ac.in
                </a>
                <br />
                Web:&nbsp;
                <a
                  href="http://wgbis.ces.iisc.ac.in/biodiversity"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  http://wgbis.ces.iisc.ac.in/biodiversity
                </a>
                ,&nbsp;
                <br />
                <a
                  href="http://wgbis.ces.iisc.ac.in/energy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  http://wgbis.ces.iisc.ac.in/energy
                </a>
              </p>
            </div>
            <div className="col-3 d-flex justify-content-evenly">
              <img
                style={{fontSize: "0.9em", height: 70, width: 70, mixBlendMode: "multiply" }}
                src="images/EIACP_Logo.png"
              />
              <img
                style={{fontSize: "0.9em", height: 70, width: 70, mixBlendMode: "multiply" }}
                src="images/ENVIS Logo_FINAL.png"
              />
            </div>
          </div>
</div>
        }
        />

    )
}
export default AbstractPage;